<img [src]="left" class="left">
<img [src]="middle" [class.flipped]="state" class="middle">
<img [src]="right" class="right">
